import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { getInlineLoader } from "../Helpers";
import banner1 from '../assets/banner1.jpg';
import banner2 from '../assets/banner2.jpg';
import banner3 from '../assets/banner3.jpg';
import pr1 from '../assets/pr1.jpg';
import pr2 from '../assets/pr2.jpg';
import pr3 from '../assets/pr3.jpg';
import pr4 from '../assets/pr4.jpg';
import pr5 from '../assets/pr5.jpg';
import pr6 from '../assets/pr6.jpg';
import pr7 from '../assets/pr7.jpg';
import pr8 from '../assets/pr8.jpg';
import pr9 from '../assets/pr9.jpg';
import pr10 from '../assets/pr10.jpg';
import pr11 from '../assets/pr11.jpg';
import pr12 from '../assets/pr12.jpg';
import re1 from '../assets/re1.jpeg';
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { FaArrowCircleRight } from "react-icons/fa";
import HorizontalImageStrip from "./HorizontalImagesStrip";
import OneService from "./OneService";
import medical_pic from '../assets/photos/medical_equipments/18.jpg';
import promo_pic from '../assets/photos/promotional_materials/12.jpg';
import education_pic from '../assets/photos/educational_solutions/1.jpg';
import moble_pic from '../assets/photos/smart_mobile/2.jpg';
import realestate_pic from '../assets/photos/real_estate/3.jpg';
import telecom_pic from '../assets/photos/telecom_solutions/6.jpg';
import ict_pic from '../assets/photos/ict_solutions/1.jpg';
import agri_pic from '../assets/photos/agricultular_solutions/1.jpg';
import energ_pic from '../assets/photos/energy_solutions/1.jpg';
import green_pic from '../assets/photos/energy_solutions/3.jpg';
import logistics_pic from '../assets/photos/logistics/4.jpg';

export default function ServicesBanner1(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);

	async function init() {
		setReady(false);
		// initializations...
		setReady(true);
	}

	useEffect(() => {
		init();
	}, []);

	

	if (ready) {
		return (
			<div 
				className="MainBodySection bg-background"
				style={{
					paddingTop: "50px",
					paddingBottom: "50px"
				}}
			>
				
				<div 
					className="container"
					
				>
					
				

					

					<div className="row">

						<div className="col-md-12">
							<h6
								className="main-section-title"
							>
								Our Services
							</h6>
						</div>

						<div className="col-md-6 mb-1 mt-1">
							<OneService
								title="Medical Equipments"
								image={medical_pic}
								navToLink={{
									item: 'services',
									subItem: 'medical_equipments'
								}}
							/>
						</div>

						<div className="col-md-6 mb-1 mt-1">
							<OneService
								title="Promotional Material Solutions"
								image={promo_pic}
								navToLink={{
									item: 'services',
									subItem: 'promotional_materials'
								}}
							/>
						</div>

						<div className="col-md-4 mb-1 mt-1">
							<OneService
								title="Educational Solutions"
								image={education_pic}
								navToLink={{
									item: 'services',
									subItem: 'educational_solutions'
								}}
							/>
						</div>
						
						<div className="col-md-4 mb-1 mt-1">
							<OneService
								title="Smart Mobile Devices & Solutions"
								image={moble_pic}
								navToLink={{
									item: 'services',
									subItem: 'smart_mobile'
								}}
							/>
						</div>

						<div className="col-md-4 mb-1 mt-1">
							<OneService
								title="Real Estate Solutions"
								image={realestate_pic}
								navToLink={{
									item: 'services',
									subItem: 'real_estate'
								}}
							/>
						</div>

						<div className="col-md-8 mb-1 mt-1">
							<OneService
								title="Telecommunicational Solutions"
								image={telecom_pic}
								navToLink={{
									item: 'services',
									subItem: 'telecom_solutions'
								}}
							/>
						</div>

						<div className="col-md-4 mb-1 mt-1">
							<OneService
								title="ICT Products & Security Solutions"
								image={ict_pic}
								navToLink={{
									item: 'services',
									subItem: 'ict_solutions'
								}}
							/>
						</div>


						<div className="col-md-4 mb-1 mt-1">
							<OneService
								title="Agricultural Implements Solutions"
								image={agri_pic}
								navToLink={{
									item: 'services',
									subItem: 'agricultular_solutions'
								}}
							/>
						</div>

						<div className="col-md-4 mb-1 mt-1">
							<OneService
								title="Renewable Energy Solutions"
								image={energ_pic}
								navToLink={{
									item: 'services',
									subItem: 'energy_solutions'
								}}
							/>
						</div>

						<div className="col-md-4 mb-1 mt-1">
							<OneService
								title="Logistics"
								image={logistics_pic}
								navToLink={{
									item: 'services',
									subItem: 'logistics'
								}}
							/>
						</div>

						
						
					</div>

					
				</div>
					
				
			</div>
		);
	} else {
		return (
			<div className="container mSupportLoading">
				{getInlineLoader()}
			</div>
		);
	}
}
